import { createSlice } from "@reduxjs/toolkit";
import { Country } from "../../countries/store/slice";

export type Route = {
  id: number;
  ferry_id: string;
  company_name: string;
  departure_country: Country;
  arrival_country: Country;
  description: string;
  notes?: string;
  is_transit: boolean;
  plug_in: boolean;
  adr: boolean;
  tonnage_cargo: boolean;
  all_vehicle_types: boolean;
  mandatory_driver_details: boolean;
  can_edit_booking: boolean;
  validity_days: number;
  cancellation_cut_off: string;
  ferry_line_id: number;
};

type InitialState = {
  data: Route[];
  isLoading: boolean;
};

const initialState: InitialState = {
  data: [],
  isLoading: false,
};

const routeSlice = createSlice({
  name: "routeSlice",
  initialState,
  reducers: {
    fetchData: (state, action) => {
      state.isLoading = true;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    reset: () => initialState,
  },
});

export default routeSlice;
